import {PageHeader} from "../components/PageHeader";
import {LegalDocument} from "../components/LegalDocument";
import {format, legalPages} from "../i18n";
import {legal} from "../legal";

// The policy is src/i18n/en/legal/privacy.md. Keep it in step with what the site, the API and the products actually
// collect and how long they keep it, and update legal.privacyEffective with any change.
export function PrivacyPage() {
    return (
        <div className="legal-text">
            <PageHeader title={legalPages.privacy.title} description={legalPages.privacy.description}/>
            <p className="text-body-secondary">{format(legalPages.effective, { date: legal.privacyEffective })}</p>
            <LegalDocument markdown={legalPages.privacy.document} values={legal}/>
        </div>
    );
}
